module.exports = __webpack_public_path__ + "img/top4.856c67fa.jpg";